export const OrganizationParametersGeneration = organizationData => {
  const options = new URLSearchParams()
  options.append('name', organizationData.name)
  options.append('zoho_prefix', organizationData.zoho_prefix)
  options.append('slug', organizationData.slug ?? '')

  return options
}
